var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephonietoclient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1666 25.5V23.8333C24.1666 22.9493 23.8154 22.1014 23.1903 21.4763C22.5652 20.8512 21.7173 20.5 20.8333 20.5H14.1666C13.2825 20.5 12.4347 20.8512 11.8096 21.4763C11.1844 22.1014 10.8333 22.9493 10.8333 23.8333V25.5M20.8333 13.8333C20.8333 15.6743 19.3409 17.1667 17.4999 17.1667C15.659 17.1667 14.1666 15.6743 14.1666 13.8333C14.1666 11.9924 15.659 10.5 17.4999 10.5C19.3409 10.5 20.8333 11.9924 20.8333 13.8333Z",
    stroke: "#475467",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephonietoclient);
export default __webpack_public_path__ + "static/media/telephonietoclient.5770734ddfe1242ac99d551b2b25d2c1.svg";
export { ForwardRef as ReactComponent };